module.exports = "label,\nbtn-md,\na {\n    color: rgb(31, 112, 191);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/recherche-avancee/recherche-avancee.component.css
// module id = ./src/app/recherche-avancee/recherche-avancee.component.css
// module chunks = main